/* ═══════════════════════════════════════════════════════════
   DALFA V3 — ANIMATIONS & INTERACTIONS
   ═══════════════════════════════════════════════════════════ */

(function() {
  'use strict';

  // ── IntersectionObserver per fade-up e stagger ──────────────
  const observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('dv3-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

  function initObservers() {
    document.querySelectorAll('.dv3-fade-up, .dv3-stagger').forEach(function(el) {
      observer.observe(el);
    });
  }

  // ── Hero: parallax leggero sulle card ──────────────────────
  function initHeroParallax() {
    var grid = document.querySelector('.dv3-hero__grid');
    if (!grid) return;
    var cards = grid.querySelectorAll('.dv3-hero__product-card');
    if (!cards.length) return;

    var ticking = false;
    window.addEventListener('scroll', function() {
      if (!ticking) {
        requestAnimationFrame(function() {
          var scrollY = window.pageYOffset;
          var heroH = grid.offsetHeight;
          if (scrollY < heroH) {
            var progress = scrollY / heroH;
            cards.forEach(function(card, i) {
              var speed = 0.04 + (i % 3) * 0.02;
              var dir = i % 2 === 0 ? -1 : 1;
              card.style.transform = 'translateY(' + (progress * speed * dir * 60) + 'px)';
            });
          }
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  // ── Count-up per sezione Numeri ────────────────────────────
  function countUp(el) {
    var target = el.getAttribute('data-count');
    var suffix = el.getAttribute('data-suffix') || '';
    var prefix = el.getAttribute('data-prefix') || '';
    var duration = 1400;
    var start = performance.now();

    // Prova a parsare il numero
    var numMatch = target.match(/[\d.]+/);
    if (!numMatch) { el.textContent = prefix + target + suffix; return; }
    var endVal = parseFloat(numMatch[0]);
    var isFloat = numMatch[0].includes('.');

    function update(now) {
      var elapsed = now - start;
      var progress = Math.min(elapsed / duration, 1);
      // Easing
      var ease = 1 - Math.pow(1 - progress, 3);
      var current = endVal * ease;
      var display = isFloat ? current.toFixed(1) : Math.round(current);
      el.textContent = prefix + display + suffix;
      if (progress < 1) requestAnimationFrame(update);
    }
    requestAnimationFrame(update);
  }

  function initCounters() {
    var counterObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          countUp(entry.target);
          counterObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });

    document.querySelectorAll('[data-count]').forEach(function(el) {
      counterObserver.observe(el);
    });
  }

  // ── Marquee: pausa su hover ────────────────────────────────
  function initMarquee() {
    document.querySelectorAll('.dv3-marquee__track').forEach(function(track) {
      track.addEventListener('mouseenter', function() {
        track.style.animationPlayState = 'paused';
      });
      track.addEventListener('mouseleave', function() {
        track.style.animationPlayState = 'running';
      });
    });
  }

  // ── Hero: cursor custom (opzionale) ───────────────────────
  function initHeroCursor() {
    var hero = document.querySelector('.dv3-hero');
    if (!hero) return;
    // Solo desktop
    if (window.innerWidth < 768) return;
  }

  // ── Init ────────────────────────────────────────────────────
  function init() {
    initObservers();
    initHeroParallax();
    initCounters();
    initMarquee();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
